import  { createContext } from 'react';
import { SchedulesState, SchedulesAction } from '../types';

interface ContextProps {
  state: SchedulesState;
  dispatch: (action: SchedulesAction) => void;
}

export const SchedulesContext = createContext({} as ContextProps);
